import { BREAKPOINTS } from '../../model/model';
import { BOARD } from '../../model/msg/board';
import {isDefined, not, isNotDefined, truthy, falsy, getResolution, each, anyOf, parseInt10} from '../../utils/util';
import { getDatasWithOption } from '../../utils/service';

class ConceptArt {
  constructor(options) {
    const _ = this;

    // const
    _.IMAGEVIEWER_ID = 'imageviewer-rwd';
    _.CAROUSEL_HEIGHT = 165;

    // variables
    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      breakpoint: BREAKPOINTS,
      global: window
    }, options);

    _.contiGroupData = [];
    _.data = null;

    _.global = (_.option.global) ? _.option.global : window;

    _.currentResolution = '';
    _.currentGroupData = null;
    _.currentIndex = 0;

    _.isStartChangeImageByImageViewer = false;
    _.isStartChangeImageBySlick = false;
    _.isDraggingSlickWrap = false;

    _.wrap = null;
    _.imageViewer = null;

    _.carouselWrap = null;
    _.slickWrap = null;

    _.msg = {
      FAIL_LOAD_CONCEPTART_DATA: '원화 데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    };
  }

  init() {
    const _ = this;

    _.wrap = _.option.wrap;

    // getDatasWithOption([{
    //   type: 'GET',
    //   url: _.option.apiPath,
    //   dataType: 'json',
    //   contentType: 'application/json',
    //   xhrFields: {withCredentials: true}
    //
    // }], (data) => {
    //   _.data = data;
    //
    //   if (not(Array.isArray)(_.data) || _.data.length <= 0) {
    //     _.setNoData();
    //
    //   } else {
    //     _.data.reverse();
    //
    //     _.setInstance();
    //   }
    //
    // }, (data) => {
    //   _.global.alert(_.msg.FAIL_LOAD_CONCEPTART_DATA); // '원화 데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    // });
    getDatasWithOption([{
      type: 'GET',
      url: _.option.apiDomain +'/conti/getContentGroup?service=lineage&groupAlias=lineage-art&subAlias=ko-KR',
      dataType: 'json',
      contentType: 'application/json',
      Accept: 'application/json'
    }], (data) => {
      if(not(Array.isArray)(data) || data.length <= 0) {
        _.setNoData();
      } else {
        data.forEach(item => {
          _.contiGroupData.push(JSON.parse(item.jsonData));
        });
        console.log( ' success _.contiGroupData : ', _.contiGroupData );
        // _.setData(_.contiGroupData.reverse());
        _.data = _.contiGroupData.reverse();
        _.setInstance();
      }
    }, (data) => {
      _.global.alert(_.msg.FAIL_LOAD_CONCEPTART_DATA); // '원화 데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });

    return _;
  }

  setData(data) {
    const _ = this;

    let items = [];
    each(data, function (group) {
      if (Array.isArray(group.groups) && group.groups.length > 0) {
        each(group.groups, function (item) {
          items.push(item);
        });
      }
    });

    _.data = items;

  }

  setInstance() {
    const _ = this;

    _.setList();

    $(_.global).on('resize', $.proxy(_.resize, _));

    _.resize();
  }

  setNoData() {
    const groupListWrap = $('> ul', this.wrap);
    groupListWrap.empty().append(`<li class="nodata">${BOARD.NO_ITEM}</li>`);
  }

  setList() {
    const _ = this;

    console.log('# setList() _.data : ', _.data );


    let groupData, firstItem, thumbnailSrc, tpl = '';
    for (let i = 0, max = _.data.length; i < max; i++) {
      groupData = _.data[i];
      firstItem = groupData.groups[0];

      if (!firstItem) continue;

      // change by request from UI developer.
      // thumbnailSrc = (firstItem.img.thumbnailSrc) ? firstItem.img.thumbnailSrc : firstItem.img.src;
      thumbnailSrc = firstItem.img.src || '';

      tpl += _.getListTpl(i + 1, thumbnailSrc, groupData.artTitle, groupData.groups.length);
    }

    let groupListWrap = $('> ul', _.wrap);
    groupListWrap.empty().append(tpl);

    // set events
    $('li', groupListWrap).on('click', function (evt) {
      let btn = $(this),
        groupIndex = parseInt(btn.attr('data-index'), 10),
        groupData = _.data[groupIndex - 1];

      if (!groupData) return;

      // make array for open imageViewer. memoization pattern.
      if (falsy(groupData.isArranged)) {
        let imgObj;
        for (let i = 0, max = groupData.groups.length; i < max; i++) {
          imgObj = groupData.groups[i].img;

          if (!imgObj.thumbnailSrc) imgObj.thumbnailSrc = imgObj.src || '';
        }

        groupData.isArranged = true;
      }

      // set instances
      _.setImageViewer(groupData);
      _.setImageViewerTopBarTitle(groupData.groups[0].title);

      _.currentGroupData = groupData;

      _.currentIndex = 1;
    });
  }

  getListTpl(index, thumbnailSrc, title, itemsLength) {
    return `<li class="no${index}" data-index="${index}">
              <div class="thumb" style="background-image:url(${thumbnailSrc});"></div>

              <article>
                <h3>${title}</h3>
                <span>(${itemsLength}종)</span>
              </article>
            </li>`;
  }

  setImageViewer(groupData) {
    const _ = this,
      firstImgIndex = 1;

    if (isNotDefined(_.imageViewer)) {
      let imgObj, imgObjs = [];
      for (let i = 0, max = groupData.groups.length; i < max; i++) {
        // images.push(groupData.groups[i].src);

        imgObj = groupData.groups[i].img;
        imgObjs.push({src: imgObj.src, w: parseInt(imgObj.width, 10), h: parseInt(imgObj.height, 10)});
      }

      _.imageViewer = new nc.ui.ImageViewerRWD($('body'), imgObjs, {
        // - custom options
        // originViewerUrl: 'http://m.lineage2.plaync.com/board/result/viewimage?imgSrc=',
        // commentUrl: 'http://m.lineage2.plaync.com/board/image/commentList?articleId=606818',
        isPreloadImages: false,
        id: _.IMAGEVIEWER_ID,
        topBarTitle: groupData.artTitle || '',
        hasDownloadFileBtn: false,
        readyCallback: function () {
          _.setCarousel(groupData);
          _.resizeForcibly();

          _.activateCarouselItem(firstImgIndex);
        },

        // - photoswipe library base options - http://photoswipe.com/documentation/options.html
        photoswipe: {
          // arrowEl: true, ...

          // TODO - change
          // errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>'
        }
      });
      _.imageViewer.slideByUrl(firstImgIndex - 1);

      // set events
      _.imageViewer.listen('destroy', function () {
        _.destroyImageViewer(true);
        _.destroyCarousel();
      });

      _.imageViewer.listen('afterChange', function () {
        const index = _.imageViewer.getCurrentIndex() + 1;

        if (_.isStartChangeImageBySlick) {
          _.activateCarousel(index);

        } else {
          _.isStartChangeImageByImageViewer = true;
          _.activateCarousel(index);
        }

        _.setImageViewerTopBarTitle(_.currentGroupData.groups[index - 1].title);

        _.currentIndex = index;
      });
    }
  }

  setImageViewerTopBarTitle(title) {
    if (isDefined(this.imageViewer)) this.imageViewer.setTopBarTitle(title || '');
  }

  setCarousel(groupData) {
    const _ = this;

    if (isNotDefined(_.slickWrap)) {
      let item, tpl = '';
      for (let i = 0, max = groupData.groups.length; i < max; i++) {
        item = groupData.groups[i];
        tpl += `<li><img src="${item.img.thumbnailSrc}" alt="${item.title}"></li>`;
      }

      _.carouselWrap = $(`<div class="imageviewer-rwd-carousel"><ul>${tpl}</ul></div>`);
      $('body').append(_.carouselWrap);

      _.slickWrap = $('ul', _.carouselWrap);

      _.slickWrap.slick({
        infinite: true,
        dots: false,
        speed: 250,
        arrows: true,
        slidesToShow: 8,
        slidesToScroll: 8
      });

      _.carouselWrap.on('mousewheel DOMMouseScroll', function (evt) {
        _.destroyCarousel();
        _.destroyImageViewer();
      });

      _.slickWrap.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (_.isStartChangeImageByImageViewer === true) {
          // change image by click thumbnail, or from imageViewer

        } else {
          // swipe slick thumbnail or click arrow button in slick
          _.isStartChangeImageBySlick = true;

          const index = nextSlide + 1;
          _.goToImageViewer(index);
          _.setImageViewerTopBarTitle(_.currentGroupData.groups[index - 1].title);
        }

        _.isStartChangeImageByImageViewer = false;
        _.isStartChangeImageBySlick = false;
      });

      // detect drag and click
      $('.slick-track').on('mousedown', '.slick-slide', (evt) => {
        _.isDraggingSlickWrap = false;
      });
      $('.slick-track').on('mousemove', '.slick-slide', (evt) => {
        _.isDraggingSlickWrap = true;
      });
      $('.slick-track').on('mouseup', '.slick-slide', function (evt) {
        if (_.isDraggingSlickWrap === true) {
          // this is drag action.

        } else {
          _.isStartChangeImageByImageViewer = true;

          const index = parseInt($(this).attr('data-slick-index'), 10) + 1;
          _.goToImageViewer(index);
          _.setImageViewerTopBarTitle(_.currentGroupData.groups[index - 1].title);
        }

        _.isDraggingSlickWrap = false;
      });
    }
  }

  goToImageViewer(index) {
    const idx = (index >= 1) ? index - 1 : 0;
    this.imageViewer.goTo(idx);
  }

  goToCarousel(index) {
    const idx = (index >= 1) ? index - 1 : 0;
    this.slickWrap.slick('slickGoTo', idx);
  }

  activateCarousel(index) {
    const _ = this;

    if (index === _.currentIndex) return;

    _.goToCarousel(index);
    _.activateCarouselItem(index);
  }

  activateCarouselItem(index) {
    const _ = this;

    let slides = $('.slick-slide', _.slickWrap);
    slides.removeClass('on');

    let activateSlide = slides.filter(function () {
      let slideIndex = parseInt($(this).attr('data-slick-index'), 10);
      return slideIndex === (index - 1);
    });

    activateSlide.addClass('on');
  }

  destroyImageViewer(isDestroyOnlyContainer) {
    const _ = this;

    if (falsy(isDestroyOnlyContainer)) {
      if (isDefined(_.imageViewer)) _.imageViewer.hide();
    }
    _.imageViewer = null;

    $('#' + _.IMAGEVIEWER_ID).remove();
  }

  destroyCarousel() {
    const _ = this;

    if (truthy(_.isCarouselInitialized())) {
      // destroy slick
      if (_.slickWrap && _.slickWrap.length) {
        const slickTrack = $('.slick-track', _.slickWrap);
        slickTrack.off('mousedown');
        slickTrack.off('mousemove');
        slickTrack.off('mouseup');

        _.slickWrap.off('beforeChange');
        _.slickWrap.slick('unslick');
      }
      _.slickWrap = null;

      // destroy carousel
      if (_.carouselWrap && _.carouselWrap.length) {
        _.carouselWrap.off('mousewheel DOMMouseScroll');
        _.carouselWrap.remove();
      }
      _.carouselWrap = null;
    }
  }

  isCarouselInitialized() {
    const _ = this;

    if (_.slickWrap && _.slickWrap.length) return _.slickWrap.hasClass('slick-initialized');
    return false;
  }

  resize(evt) {
    const _ = this,
      resolution = getResolution(_.option.breakpoint, _.global);

    if (resolution !== _.currentResolution) _.resizeByResolution(resolution);

    _.currentResolution = resolution;
  }

  resizeForcibly() {
    const _ = this,
      resolution = getResolution(_.option.breakpoint, _.global);

    _.resizeByResolution(resolution);

    _.currentResolution = resolution;
  }

  resizeByResolution(resolution) {
    const _ = this;

    if (isNotDefined(_.imageViewer)) return;

    switch (resolution) {
      case 'max' :
        _.imageViewer.setHeight(window.innerHeight - _.CAROUSEL_HEIGHT);
        break;

      case 'pc' :
        _.imageViewer.setHeight(window.innerHeight - _.CAROUSEL_HEIGHT);
        break;

      case 'tablet' :
        _.imageViewer.setHeight(window.innerHeight - _.CAROUSEL_HEIGHT);
        break;

      case 'phone' :
        _.imageViewer.setHeight(window.innerHeight);
        break;
    }
  }
}

export default ConceptArt;


// WEBPACK FOOTER //
// ./_src/js/download/conceptArt/ConceptArt.js